import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin" }
const _hoisted_2 = { class: "management" }
const _hoisted_3 = { class: "machine-table" }
const _hoisted_4 = { class: "head-box" }
const _hoisted_5 = { class: "machine-form" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, " Select Mac Address ", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Manager", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 5 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select User", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 6,
  class: "machine-use"
}
const _hoisted_20 = {
  for: "true",
  class: "machine-use-true-label"
}
const _hoisted_21 = {
  for: "false",
  class: "machine-use-false-label"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

import { onMounted, computed, ref, watchEffect } from "vue";
import AdministratorTable from "@/components/AdministratorTable.vue";
import { userUseStore } from "@/store/user";
import { adminUseStore } from "@/store/admin";
import {
  deleteMachineAxios,
  machineAddAxios,
  machineSettingAxios,
  machineTableAxios,
  userListAxios,
} from "@/service/admin.service";
import { Device } from "@/interface/device";
import { groupListAxios, subGroupListAxios } from "@/service/super.service";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = userUseStore();
const adminStore = adminUseStore();

const machineAddForm = ref({
  macAddress: "",
  group: "",
  manager: "",
  userName: "",
  siteName: "",
  lon: "",
  lat: "",
  use: true,
});

const state = ref({
  adminGroup: sessionStorage.getItem("group"),
  formCheck: 0,
  groupList: [] as any[],
  subGroupList: [] as any[],
});

const machineTable = computed(() => {
  const item: Device[] = userStore.deviceList.map((val: Device) => {
    return {
      no: val.no,
      group: val.group,
      sub_group: val.sub_group,
      user_name: val.user_name,
      mac_addr: val.mac_addr,
      site_name: val.site_name,
      lon: val.lon,
      lat: val.lat,
      use: val.use,
    };
  });
  return {
    header: [
      { label: "No" },
      { label: "Group" },
      { label: "Manager" },
      { label: "User Name" },
      { label: "Mac" },
      { label: "Site Name" },
      { label: "Lat" },
      { label: "Lon" },
      { label: "Use" },
    ],
    item: item,
  };
});

const formClear = async () => {
  machineAddForm.value.macAddress = "";
  machineAddForm.value.group = String(state.value.adminGroup);
  machineAddForm.value.manager = "";
  machineAddForm.value.userName = "";
  machineAddForm.value.siteName = "";
  machineAddForm.value.lon = "";
  machineAddForm.value.lat = "";
  machineAddForm.value.use = true;
};

const changeFormAdd = async () => {
  if (state.value.formCheck === 1) {
    state.value.formCheck = 0;
    await formClear();
  }
};

const changeFormRefactor = async () => {
  if (state.value.formCheck === 0) {
    state.value.formCheck = 1;
    await formClear();
  }
};

const selectGroup = async (group: string) => {
  if (machineAddForm.value.group === "") {
    return;
  } else {
    state.value.subGroupList = await subGroupListAxios(group);
    await userListAxios(group);
  }
};

const selectMachine = (mac: string) => {
  if (machineAddForm.value.macAddress === "") {
    return;
  } else {
    const findMac = userStore.deviceList.find((val: Device) => {
      return val.mac_addr === mac;
    });
    if (findMac) {
      machineAddForm.value.userName = findMac.user_name;
      machineAddForm.value.group = findMac.group;
      machineAddForm.value.manager = findMac.sub_group;
      machineAddForm.value.siteName = findMac.site_name;
      machineAddForm.value.lon = findMac.lon;
      machineAddForm.value.lat = findMac.lat;
      machineAddForm.value.use = findMac.use;
    }
  }
};

const machineInsert = async () => {
  await machineAddAxios(
    machineAddForm.value.macAddress,
    machineAddForm.value.userName,
    machineAddForm.value.group,
    machineAddForm.value.manager,
    machineAddForm.value.siteName,
    machineAddForm.value.lon,
    machineAddForm.value.lat,
    machineAddForm.value.use
  );
  await formClear();
  if (state.value.adminGroup) {
    await machineTableAxios(state.value.adminGroup);
    await userListAxios(state.value.adminGroup);
  }
};

const machineRefactor = async () => {
  await machineSettingAxios(
    machineAddForm.value.userName,
    machineAddForm.value.siteName,
    machineAddForm.value.group,
    machineAddForm.value.manager,
    machineAddForm.value.macAddress,
    machineAddForm.value.lon,
    machineAddForm.value.lat,
    machineAddForm.value.use
  );

  await formClear();
  if (state.value.adminGroup) {
    await machineTableAxios(state.value.adminGroup);
    await userListAxios(state.value.adminGroup);
  }
};

const deleteItem = async (pick: Device[]) => {
  await deleteMachineAxios(pick[0].mac_addr);
  if (state.value.adminGroup) {
    await machineTableAxios(state.value.adminGroup);
    await userListAxios(state.value.adminGroup);
  }
};

onMounted(async () => {
  machineAddForm.value.group = String(state.value.adminGroup);
  if (state.value.adminGroup === "super") {
    state.value.groupList = await groupListAxios();
    state.value.subGroupList = await subGroupListAxios();
  } else if (state.value.adminGroup) {
    state.value.subGroupList = await subGroupListAxios(state.value.adminGroup);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("machine_list")), 1)
        ]),
        _createVNode(AdministratorTable, {
          header: _unref(machineTable).header,
          item: _unref(machineTable).item,
          height: 80,
          onDeleteItem: deleteItem
        }, null, 8, ["header", "item"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["form-change-add", { active: state.value.formCheck === 0 }]),
            onClick: changeFormAdd
          }, _toDisplayString(_ctx.$t("add")), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["form-change-refactor", { active: state.value.formCheck === 1 }]),
            onClick: changeFormRefactor
          }, _toDisplayString(_ctx.$t("edit")), 3)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (!state.value.formCheck)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "mac-input",
                  id: "mac",
                  type: "text",
                  placeholder: "Mac Address",
                  maxlength: "12",
                  oninput: "this.value = this.value.replace(/[^0-9a-fA-F]/g, '').replace(/(\\..*)\\./g, '$1');",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((machineAddForm.value.macAddress) = $event))
                }, null, 512), [
                  [_vModelText, machineAddForm.value.macAddress]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  class: "select-mac",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((machineAddForm.value.macAddress) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (selectMachine(machineAddForm.value.macAddress)))
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).deviceList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.mac_addr
                    }, _toDisplayString(item.mac_addr), 9, _hoisted_9))
                  }), 128))
                ], 544), [
                  [_vModelSelect, machineAddForm.value.macAddress]
                ])
              ])),
          (state.value.adminGroup === 'super')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _withDirectives(_createElementVNode("select", {
                  class: "select-group",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((machineAddForm.value.group) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (selectGroup(machineAddForm.value.group)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.groupList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_11))
                  }), 128))
                ], 544), [
                  [_vModelSelect, machineAddForm.value.group]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  class: "group-input",
                  id: "group",
                  type: "text",
                  placeholder: "Group Name",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((machineAddForm.value.group) = $event))
                }, null, 512), [
                  [_vModelText, machineAddForm.value.group]
                ])
              ])),
          (machineAddForm.value.group !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  class: "select-group",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((machineAddForm.value.manager) = $event))
                }, [
                  _hoisted_14,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.subGroupList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item.sub_group
                    }, _toDisplayString(item.sub_group), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, machineAddForm.value.manager]
                ])
              ]))
            : _createCommentVNode("", true),
          (machineAddForm.value.manager !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _withDirectives(_createElementVNode("select", {
                  required: "",
                  class: "select-user",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((machineAddForm.value.userName) = $event))
                }, [
                  _hoisted_17,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adminStore).userList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vModelSelect, machineAddForm.value.userName]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              class: "site-input",
              id: "site",
              type: "text",
              placeholder: "Site Name",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((machineAddForm.value.siteName) = $event))
            }, null, 512), [
              [_vModelText, machineAddForm.value.siteName]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              class: "lon-input",
              id: "lon",
              type: "text",
              placeholder: "Machine Lon",
              maxlength: "10",
              oninput: "this.value = this.value.replace(/[^0-9.-]/g, '').replace(/(\\..*)\\./g, '$1');",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((machineAddForm.value.lon) = $event))
            }, null, 512), [
              [_vModelText, machineAddForm.value.lon]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "lat-input",
              id: "lat",
              type: "text",
              placeholder: "Machine Lat",
              maxlength: "10",
              oninput: "this.value = this.value.replace(/[^0-9.-]/g, '').replace(/(\\..*)\\./g, '$1');",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((machineAddForm.value.lat) = $event))
            }, null, 512), [
              [_vModelText, machineAddForm.value.lat]
            ])
          ]),
          (state.value.formCheck)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((machineAddForm.value.use) = $event)),
                  value: true,
                  type: "radio",
                  name: "use",
                  id: "true"
                }, null, 512), [
                  [_vModelRadio, machineAddForm.value.use]
                ]),
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("use")), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((machineAddForm.value.use) = $event)),
                  value: false,
                  type: "radio",
                  name: "use",
                  id: "false"
                }, null, 512), [
                  [_vModelRadio, machineAddForm.value.use]
                ]),
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("un_use")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (!state.value.formCheck)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: 
                machineAddForm.value.macAddress === '' ||
                machineAddForm.value.group === '' ||
                machineAddForm.value.manager === '' ||
                machineAddForm.value.userName === '' ||
                machineAddForm.value.siteName === '' ||
                machineAddForm.value.lon === '' ||
                machineAddForm.value.lat === ''
              ,
                  class: "create-btn",
                  onClick: machineInsert
                }, _toDisplayString(_ctx.$t("machine_create")), 9, _hoisted_22))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: machineRefactor,
                  class: "refactor-btn",
                  disabled: 
                machineAddForm.value.macAddress === '' ||
                machineAddForm.value.group === '' ||
                machineAddForm.value.manager === '' ||
                machineAddForm.value.userName === '' ||
                machineAddForm.value.siteName === '' ||
                machineAddForm.value.lon === '' ||
                machineAddForm.value.lat === ''
              
                }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_23))
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})